


















import Vue from 'vue'
import { Component, Emit, Prop, PropSync } from 'vue-property-decorator'

import { warningNotificationWrapper } from '../../../../../../../../../../../../logic/helpers/NotificationService'
import FieldTitle from '../../../../../../../../../../../Pi/components/FieldTitle.vue'
import PiDropdownInput from '../../../../../../../../../../../PiDropdownInput.vue'
import CustomEditor from '../../../../../../../../Editor/CustomEditor'
import { ActionNodeProps } from '../../../../../logic/types'

@Component({
  components: {
    PiDropdownInput,
    FieldTitle,
  }
})
export default class NotifyUsersActionAddUserField extends Vue {
  @PropSync('isLoading') isLoad!: boolean

  @Prop() editor!: CustomEditor

  @Prop() usersOptions!: ActionNodeProps['usersOptions']

  addUserHandler(userData: string): void {
    if (userData) {
      this.isLoad = true

      this.editor.getUsersInfo([ userData ])
        .finally(() => this.isLoad = false)
        .then(({ data }) => data.length ? this.addUser(data[0].info.id) : this.addToNotFound(userData))
    } else {
      warningNotificationWrapper(this.$t('warning').toString(), this.$t('fill_data_alert').toString())
    }
  }

  @Emit()
  addUser(id: number): number {
    return id
  }

  @Emit()
  addToNotFound(value: number | string): number | string {
    return value
  }
}
